<template>
		<div class="signin-bg">
			<Header :show_language_items="false" :show_menu_items="false" :is_sticky="true"/>
			<div class="inblock">
				<h4 class="inblock-title">
						{{ $t("message.welcome") }}
				</h4>
				<FormSeparator />
				<FormSeparator />
				<TextInput :placeholder='$t("message.ng_login.email_login")' v-model="pull.customer_email" />
				<FormSeparator />
				<PasswordInput :placeholder='$t("message.ng_login.password")' v-model="pull.customer_password" />
				<div class="text-right">
					<ButtonLink :label='$t("message.ng_login.forgot_password")' @click="show_forgot_modal" />					
				</div>
				<div class="mb-2 mt-4">
					<ButtonSuccess :label='$t("message.ng_login.login_button")' @click="submit" :disabled="login_disabled" />
				</div>
				<div class="mb-2 mt-4">
					<ButtonWhite :label='$t("message.ng_login.register_button")' @click="gotoRegistration" />
				</div>								
		</div>
	<!--<div class="signin-bg">
			<div class="form-block">
					<div class="card-holder">
							<div class="">
									<div class="">
											<div class="">
													<logo classes="mt-5 mb-3" />
													<a href="/" class="underlogotext">{{
															$t("message.menu.back_to_home")
													}}</a>

													<h4 class="card-title">
															{{ $t("message.menu.signin") }}
													</h4>
											</div>

											<div class="">
													<div
															class="alert alert-success"
															v-if="show_email_confirmed_alert"
													>
															{{ $t("message.email-confirmed") }}
													</div>
													<form @submit.prevent.stop="submit">
															<div :class="['form-group d-block']">
																	<label for="subject">{{
																			$t("message.reg_form.email_login")
																	}}</label>
																	<input
																			type="email"
																			class="form-control"
																			v-model="pull.customer_email"
																			:placeholder="$t('message.reg_form.email_login_place')"
																			autocomplete="off"
																			style="cursor: auto"
																	/>
															</div>
															<password
																	v-model="pull.customer_password"
																	label="Пароль"
																	:placeholder="$t('message.reg_form.password_place')"
																	autocomplete="off"
																	xstyle="cursor: auto;"
																	id="customer_password"
															/>
															<div class="text-left mb-2 mt-4">
																	<button
																			id="submit-sign-in-button"
																			:class="[
																					'btn btn-round btn-primary btn-lg',
																					loading ? 'pl-5' : '',
																			]"
																			@click.prevent.stop="submit"
																			style="position: relative; padding-right: 28px"
																			:disabled="login_disabled"
																	>
																			<div
																					class="loading my-1 loading-button"
																					v-if="loading"
																			></div>
																			{{ $t("message.login_form.submit_button") }}
																			<svg
																					width="16"
																					height="16"
																					viewBox="0 0 16 16"
																					fill="none"
																					xmlns="http://www.w3.org/2000/svg"
																			>
																					<path
																							fill-rule="evenodd"
																							clip-rule="evenodd"
																							d="M5.52864 3.52876C5.78899 3.26841 6.2111 3.26841 6.47145 3.52876L10.4714 7.52876C10.7318 7.78911 10.7318 8.21122 10.4714 8.47157L6.47145 12.4716C6.2111 12.7319 5.78899 12.7319 5.52864 12.4716C5.26829 12.2112 5.26829 11.7891 5.52864 11.5288L9.05723 8.00016L5.52864 4.47157C5.26829 4.21122 5.26829 3.78911 5.52864 3.52876Z"
																							fill="white"
																					/>
																			</svg>
																	</button>
															</div>
															<div class="text-left">
																	<button
																			class="text-button btn pl-0"
																			@click.prevent.stop="show_forgot_modal"
																	>
																			{{ $t("message.login_form.forgot_password") }}
																	</button>
															</div>
															<div class="text-center" v-if="!is_bank">
																	<router-link
																			:to="{ name: 'sign-in-ecp' }"
																			class="btn btn-outline-success btn-round mx-auto"
																			>{{ $t("message.login_form.ecp_login") }}</router-link
																	>
															</div>
													</form>
											</div>
									</div>
							</div>
					</div>
			</div>
			<div class="copyright-block">
					© 2023, ATTIS Russia. All Rights Reserved
			</div>
			
	</div>-->
	<b-modal
					id="modal-forgot-password"
					size="md"
					:title="$t('message.login_form.forgot_password')"
					:hide-footer="true"
					button-size="lg"
			>
					<div class="form-group mb-2 mt-0">
							<label for="">{{ $t("message.login_form.email") }}</label>
							<input
									type="email"
									class="form-control"
									v-model="forgot_email"
									:placeholder="$t('message.login_form.email')"
									autocomplete="off"
									style="cursor: auto"
							/>
					</div>
					<p class="mb-4">
							{{ $t("message.login_form.forgot_password_description") }}
					</p>
					<button
							class="btn btn-pills mx-auto btn-round btn-primary"
							@click="generate_new_password"
					>
							{{ $t("message.login_form.forgot_password_button") }}
					</button>
			</b-modal>
			<b-modal
					id="modal-reset-password"
					size="sm"
					:title="$t('message.login_form.reset_password')"
					:hide-footer="true"
					button-size="lg"
			>
					<input
							type="email"
							class="form-control"
							v-model="forgot_email"
							:placeholder="$t('message.login_form.email')"
							autocomplete="off"
							style="cursor: auto"
					/>
					<input
							type="password"
							class="form-control"
							v-model="forgot_password"
							:placeholder="$t('message.login_form.password')"
							autocomplete="off"
							style="cursor: auto"
					/>
					<p>{{ $t("message.login_form.reset_password_description") }}</p>
					<button
							class="btn btn-pills btn-round btn-success"
							@click="set_new_password"
					>
							{{ $t("message.login_form.reset_password_button") }}
					</button>
			</b-modal>
			<b-modal
					id="modal-change-password-success"
					size="sm"
					:title="$t('message.login_form.reset_password_success')"
					:hide-footer="true"
					button-size="lg"
			>
					<p>{{ $t("message.login_form.reset_password_success_description") }}</p>
					<button
							class="btn btn-pills btn-round btn-success"
							@click="$bvModal.hide('modal-change-password-success')"
					>
							{{ $t("message.ok") }}
					</button>
			</b-modal>
			<b-modal
					id="modal-change-password-exp"
					centered
					:hide-footer="true"
					size="lg"
					:title="$t('message.account.change_password')"
			>
					<div class="alert alert-warning">
							{{ $t("message.password_expired_text") }}
					</div>
					<div class="form-group">
							<label for="old_password">{{
									$t("message.account.old_password")
							}}</label>
							<input
									type="password"
									id="old_password"
									class="form-control"
									v-model="old_password"
							/>
					</div>
					<div class="text-danger" v-if="wrong_old_password">
							{{ $t("message.account.old_password_wrong") }}
					</div>
					<div class="text-danger" v-if="insecure_new_password">
							{{ $t("message.account.insecure_new_password") }}
					</div>
					<div class="text-danger" v-if="short_new_password">
							{{ $t("message.account.short_new_password") }}
					</div>

					<div class="form-group">
							<label for="new_password">{{
									$t("message.account.new_password")
							}}</label>
							<input
									type="password"
									id="new_password"
									class="form-control"
									v-model="new_password"
							/>
					</div>
					<div class="form-group">
							<label for="confirm_password">{{
									$t("message.account.confirm_password")
							}}</label>
							<input
									type="password"
									id="confirm_password"
									class="form-control"
									v-model="confirm_password"
							/>
					</div>
					<button class="btn btn-success" @click="savePassword">
							{{ $t("message.save") }}
					</button>
			</b-modal>
</div>
</template>
<script>
var querystring = require("querystring");
import password from "../fields/password.vue";
import Header from '../newhomepage/header.vue';

import { TextInput, PasswordInput, FormSeparator, ButtonLink, ButtonSuccess, ButtonWhite } from "../simplements";
export default {
	name: "NCSSignin",
	components: { password, Header, TextInput, PasswordInput, FormSeparator, ButtonLink, ButtonSuccess, ButtonWhite },
	data() {
			return {
					login_disabled: false,

					show_email_confirmed_alert: false,

					forgot_email: "",
					forgot_password: "",
					pull: {
							customer_email: "",
							customer_password: "",
					},
					loading: false,

					old_password: "",
					new_password: "",
					confirm_password: "",

					wrong_old_password: false,
					short_new_password: false,
					insecure_new_password: false,

					timeout_on_mounted: null,
			};
	},
	mounted() {
			this.logout();

			if (this.$route.name == "email-confirmed") {
					this.show_email_confirmed_alert = true;
			}
			if (this.$route.name == "sign-in-reset") {
					if (!document.querySelector("#modal-change-password-exp.show"))
							this.$bvModal.show("modal-reset-password");
			}
			if (this.$route.name == "pwd-expired") {
					this.$bvModal.show("modal-change-password-exp");
			}
			this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
					if (modalId === "modal-change-password-exp") {
							// window.updateToken();
							this.$root.$emit("logout");
							// this.$store.commit('logout')
							// axios.get(window.base + '/account/logout')
							// window.location.reload()
					}
			});
			// console.log(window.is_token_loaded.status)
			// if(!window.is_token_loaded.status)
			// 	window.updateToken()
			this.login_disabled = true;
			this.$root.$on("token_updated", () => {
					clearTimeout(this.timeout_on_mounted);
					this.login_disabled = false;
			});
	},
	methods: {
		gotoRegistration(){
			this.$router.push({name: 'sign-up'})
		},
			logout() {
					axios
							.get(window.base + "/account/logout")
							.then(() => {
									this.refreshToken();
							})
							.catch(() => {
									this.logout();
							});
			},
			refreshToken() {
					axios
							.get(window.base + "/account/RefreshToken")
							.then((response) => {
									const regex =
											/name="__RequestVerificationToken" type="hidden" value="(.*)"/gm;
									let m;
									m = regex.exec(response.data);
									window.token = m[1];
									window.axios.defaults.headers.common["__RequestVerificationToken"] =
											window.token;
									console.log("🔒 Token updated");
									window.vue.$emit("token_updated");
									window.is_token_loaded.status = false;
							})
							.catch(() => {
									this.refreshToken();
							});
			},
			/**
				* Saves new password
				*/
			savePassword() {
					if (
							!_.isEmpty(this.old_password) &&
							!_.isEmpty(this.new_password) &&
							!_.isEmpty(this.confirm_password)
					) {
							if (this.new_password != this.confirm_password) {
									new Noty({
											theme: "light",
											type: "error",
											text: this.$t("message.account.passwords_not_equal"),
											timeout: 5000,
									}).show();
							} else {
									var formdata = new FormData();
									formdata.append("old_password", this.old_password);
									formdata.append("new_password", this.new_password);
									axios
											.post(window.base + "/account/savePassword", formdata)
											.then((response) => {
													if (response.data.status == "ok") {
															this.$bvModal.hide("modal-change-password-exp");
															this.$bvModal.show("modal-change-password-success");
															this.wrong_old_password = false;
													} else {
															if (response.data.status == "Incorrect password.") {
																	this.wrong_old_password = true;
															} else {
																	if (
																			response.data.status ==
																			"Password should contain 8 symbols, at least one number and one special character."
																	) {
																			this.short_new_password = true;
																	} else {
																			this.insecure_new_password = true;
																	}
															}
													}
											});
							}
					} else {
							new Noty({
									theme: "light",
									type: "error",
									text: this.$t("message.account.fill_all_fields"),
									timeout: 5000,
							}).show();
					}
			},
			/**
				* Sets new password for the account using token from the email
				*/
			set_new_password() {
					let fd = new FormData();
					fd.append("email", this.forgot_email);
					fd.append("password", this.forgot_password);
					fd.append("code", this.$route.params.code);
					axios.post(window.base + "/account/ResetPassword", fd).then(() => {
							this.$router.push({ name: "sign-in" });
							this.$bvModal.hide("modal-reset-password");
					});
			},
			/**
				* Sends request to generate new password
				*/
			generate_new_password() {
					var fd = new FormData();
					fd.append("email", this.forgot_email);
					axios.post(window.base + "/account/ForgotPassword", fd).then((r) => {
							if (r.data.trim() == "ok") {
									new Noty({
											theme: "light",
											type: "success",
											text: this.$root.$t("message.login_form.forgot_email_sent"),
											timeout: 5000,
									}).show();
							} else {
									new Noty({
											theme: "light",
											type: "error",
											text: this.$root.$t("message.login_form.forgot_email_not_sent"),
											timeout: 5000,
									}).show();
							}
					});
			},
			/**
				* Displays forgot password modal
				*/
			show_forgot_modal() {
					this.$bvModal.show("modal-forgot-password");
			},
			submit() {
					this.loading = true;
					var bodyFormData = new FormData();
					bodyFormData.set("userName", "Fred");
					axios
							.post(window.base + "/account/login", querystring.stringify(this.pull))
							.then((response) => {
									if (response.data.statusMessage == "PasswordExpired") {
											this.$router.push({ name: "pwd-expired" });
											this.loading = false;
											window.updateToken();
											// window.location.reload()
											this.$bvModal.show("modal-change-password-exp");
											return;
									}
									if (response.data.statusCode == 200) {
											let user_object = response.data.user;
											user_object.Roles = JSON.parse(user_object.Roles);
											this.$store.commit("login", {
													user: user_object /*JSON.parse(*/ /*.replace('"user": ', ''))*/,
											});
											this.$router.push({ name: "home-after-login" });
											this.login_disabled = true;
											window.updateToken();
											// window.location.reload()
											new Noty({
													theme: "light",
													type: "success",
													text: this.$t("message.message.login-successfull"),
													timeout: 5000,
											}).show();
											axios
													.get(window.base + "/document/getfirmfull")
													.then((response) => {
															this.$store.commit("load_firm", response.data);
													});
									} else if (response.data.statusCode == 201) {
											this.loading = false;
											this.login_disabled = true;
											window.updateToken();
											axios.get(window.base + "/account/logout");
											// .then(()=>{

											// })
											new Noty({
													theme: "light",
													type: "error",
													text: this.translate(response.data.statusMessage),
													timeout: 5000,
											}).show();
									} else {
											this.login_disabled = true;
											window.updateToken();
											axios.get(window.base + "/account/logout");
											var errorMessage = this.translate(response.data.statusMessage);

											new Noty({
													theme: "light",
													type: "error",
													text: errorMessage,
													timeout: 5000,
											}).show();
									}
									this.loading = false;
							})
							.catch((error) => {
									console.error(error);
									alert("Login " + error);
									this.loading = false;
							});
			},
			translate(string) {
					let errorMessage = "";
					switch (string) {
							case "RequestIsNotApproved":
									errorMessage = this.$t("message.message.login_request_not_approved");
									break;
							case "UserNotFound":
									errorMessage = this.$t("message.message.login_user_not_found");
									break;
							case "UserBlocked":
									errorMessage = this.$t("message.message.login_user_blocked");
									break;
							case "VerificationNeeded":
									errorMessage = this.$t("message.message.login_verification_needed");
									break;
							case "WrongCredentials":
									errorMessage = this.$t("message.message.login_wrong_credentials");
									break;
							default:
									errorMessage = this.$t("message.message.login_request_not_approved");
									break;
					}
					return errorMessage;
			},
	},
	computed: {
			is_bank() {
					return window.is_bank;
			},
			locale() {
					var locale = this.$i18n.locale;
					var _this = this;
					switch (locale) {
							case "cn":
									locale = "zh-CN";
									break;
							case "en":
									locale = "en-US";
									break;
					}
					return locale;
			},
	},
};
</script>
<style scoped>

.signin-bg {
	background-color: #fff !important;
	/* background-image: url('./../newhomepage/img_bridge_2.png'); */
	min-height: 100vh !important;
	background-repeat: no-repeat;
	background-position: center right;
}
.inblock{
	width: 28vw;
	margin: 181px auto;
}

.inblock-title{
	color: var(--neutral-10, rgba(51, 51, 51, 0.93));

	/* Display/Small */
	font-family: Roboto;
	font-size: 28px;
	font-style: normal;
	font-weight: 500;
	line-height: 32px; /* 114.286% */
	text-align: center;
}

.form-block {
	width: 100%;
	padding-right: 49vh;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}
.form-block .card-holder {
	width: 60vh;
	margin-top: auto;
	margin-bottom: auto;
}

.underlogotext {
	margin-bottom: 70px;
	color: #04416d;
	display: block;
}
h4.card-title {
	font-family: "Roboto";
	font-style: normal;
	font-weight: 400;
	font-size: 28px;
	line-height: 36px;
	/* identical to box height, or 129% */

	/* attis/primary */

	color: #04416d;
	margin-bottom: 24px;
}
.form-group {
	position: relative;
	margin-top: 20px;
	/* margin-bottom: 36px; */
	height: 56px;
}

.form-group.textarea {
	height: 112px;
}
.form-group .form-control {
	border: 0;
	height: 50px;
	position: absolute;
	box-shadow: none !important;
	outline: none !important;
	border: 1px solid #b1b1b1;
	border-radius: 4px;
	height: 56px;
}

.form-group .form-control:hover {
	border-color: #333333;
}
.form-group .form-control:focus {
	border-color: var(--color2);
}
.form-group textarea.form-control {
	height: 104px;
}
.form-group label {
	font-family: "Roboto";
	padding: 0 4px;
	background-color: #fff;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	position: absolute;
	left: 16px;
	z-index: 3;
	top: -8px;
	/* identical to box height, or 133% */

	/* neutral/30 */

	color: #797980;
}
.btn-primary {
	background: linear-gradient(90deg, var(--color1) 0%, var(--color2) 100%) !important;
	border: 0 !important;
}
#submit-sign-in-button {
	white-space: nowrap;
}
#submit-sign-in-button i,
#submit-sign-in-button svg {
	/* margin-left: 15px; */
}
.btn-dark-blue {
	color: #04416d !important;
	font-family: "Roboto" !important;
	font-style: normal !important;
	font-weight: 500 !important;
	font-size: 16px !important;
	line-height: 24px !important;
	margin-top: 40px;
}
.btn-dark-blue:hover {
	text-decoration: none !important;
	color: #333333 !important;
}
.btn-primary:disabled,
.btn-primary:disabled:hover {
	background: #e6e6e6 !important;
	color: #797980 !important;
}
.btn-primary:disabled svg,
.btn-primary:disabled svg path {
	fill: #797980 !important;
}
.copyright-block {
	font-family: "Roboto";
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	/* identical to box height, or 143% */

	/* neutral/70 */

	color: #b1b1b1;
	text-align: center;
	/* margin-top: auto; */
	margin-bottom: 20px;
	position: absolute;
	bottom: 32px;
	left: 0;
	right: 0;
}
.btn-primary {
	padding-left: 36px;
	padding-right: 36px;
	font-family: "Roboto";
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	/* identical to box height, or 143% */

	display: flex;
	align-items: center;
	letter-spacing: 0.1px;
	/* identical to box height, or 143% */

	display: flex;
	align-items: center;
	letter-spacing: 0.1px;
	transition: none !important;
	background: linear-gradient(90deg, var(--color1) 0%, var(--color2) 100%);
}
.btn-primary:hover {
	background: var(--color2) !important;
	box-shadow: none !important;
	color: #fff !important;
}
@media screen and (max-width: 768px) {
	.form-block {
			padding-right: 0;
	}
	.form-block .card-holder {
			width: 90%;
	}
	.signin-bg {
			background: transparent;
	}
}
</style>
